import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 获取邮件配置
  getEmailSetting: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/email`, "get", config),
  // 设置邮件配置
  putEmailSetting: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/email`, "put", config),
  // 测试邮件
  postSendEmail: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/email/sendTest`, "post", config),
  // 审计开关
  auditConfig: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/events/config`, "put", config),
  // 查询审计状态
  getAuditState: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/events/loginEvents/state`, "get", config),
  // 查询密码策略
  getPasswordPolicy: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/setting/passwordPolicy`, "get", config),
  // 查询密码策略
  setPasswordPolicy: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/setting/passwordPolicy`, "put", config),
  // 注册配置
  registerConfig: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/register`, "put", config),
  getRegister: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/register`, "get", config),
  // 查询双因子认证状态
  getDoubleFactor:(realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/setting/doubleFactor`, "get", config),
  // 查询双因子认证状态
  putDoubleFactor:(realmName, config) =>
    createAPI(`/idaas/admin/realms/${realmName}/setting/doubleFactor`, "put", config),
}
